import React, { useEffect, useState } from 'react'
import { Badge, Button, DropdownItem, DropdownMenu, DropdownToggle, Modal, ModalBody, UncontrolledDropdown } from 'reactstrap'
import { BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Icon, ReactDataTable } from '../../../../components/Component'
import { WEBSITE_BASE_URL } from '../../../../config'
import ToastExample from '../../../../helpers/toast'
import Content from '../../../../layout/content/Content'
import Head from '../../../../layout/head/Head'
import moment from 'moment'

import { useDispatch, useSelector } from 'react-redux'
import { acceptStore, deleteStore, getAllPendingStores } from '../../../../redux/admin/store/action'
import { nonActiveFormSubmissionStatus, openFormLoading } from '../../../../redux/common/actions'
import { Image, Table } from 'antd'



function PendingStores() {

    const dispatch = useDispatch();

    // get data from redux state
    const getSelectors = (state) => ({
        stores: state.store.pending_stores,
        form_loading: state.common.form_loading,
        form_submission_status: state.common.form_submission_status,
    });

    const { stores, form_loading, form_submission_status } = useSelector(getSelectors);

    const [showToast, setShowToast] = useState(false);
    const [modal, setModal] = useState(false);
    const [deletingStore, setDeleteStore] = useState([]); // for deleting store
    const [pendingStoreTableDatas, setPendingStoreTableDatas] = useState([]); // for deleting store


    // get all stores  onload
    useEffect(() => {
        dispatch(getAllPendingStores());
    }, []);

    // function to close the form modal
    const onFormCancel = () => {
        setModal(false);

    };

    // submit data to api
    const onFormSubmit = (e) => {
        e.preventDefault();
        dispatch(openFormLoading());
        if (modal) {
            dispatch(deleteStore(deletingStore?.id));
        }
    };

    // useEffect which watches the formsubmission of delete and create.
    useEffect(() => {

        if (modal && form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                dispatch(getAllPendingStores());

                setModal(false);
                setShowToast(true);
            }, 500);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        }
    }, [modal, form_submission_status, form_loading]);



    const onAcceptStore = (store) => {
        dispatch(acceptStore(store?.id)).then(response => {
            if (response.payload.success) {
                dispatch(getAllPendingStores());
                setShowToast(true);
                setTimeout(() => {
                    setShowToast(false);
                }, 3000);
            }
        })
    };

    //to open delete modal
    const openDeleteModal = (store) => {
        setModal(true);
        dispatch(nonActiveFormSubmissionStatus());

        setDeleteStore(store);
    };

    const dataTableColumns = [
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: "Phone",
            selector: (row) => row.phone,
            sortable: true,
        },
        {
            name: "Action",
            selector: (row) => row.salary,
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <DropdownTrans row={row} />
                </div>
            )
        },
    ];

    const DropdownTrans = ({ row }) => {
        return (
            <UncontrolledDropdown>
                <DropdownToggle tag="a" className="text-soft dropdown-toggle btn btn-icon btn-trigger">
                    <Icon name="more-h"></Icon>
                </DropdownToggle>
                <DropdownMenu right>
                    <ul className="link-list-plain">
                        <li>
                            <DropdownItem tag="a" onClick={() => { onAcceptStore(row) }}>
                                <Icon name="check-thick" />
                                Accept
                            </DropdownItem>
                        </li>
                        <li>
                            <DropdownItem
                                tag="a"
                                href="#dropdownitem"
                                onClick={(e) => { openDeleteModal(row) }}
                            >
                                <Icon name="trash" />
                                Delete
                            </DropdownItem>
                        </li>

                    </ul>
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    };

    return (
        <React.Fragment>
            <Head title="Pending Stores "></Head>

            <Content>
                <BlockHead size="sm">
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle tag="h3" page>
                               Pending Stores
                            </BlockTitle>
                            <BlockDes className="text-soft">
                                <p>You have total {stores.length} Pending Stores .</p>
                            </BlockDes>
                        </BlockHeadContent>
                        <BlockHeadContent>
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <ToastExample show={showToast} />
                                <div className="toggle-expand-content">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a href="/stores" className="btn btn-dark btn-outline-dark text-white" >
                                                <span>View Stores </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </BlockHeadContent>
                    </BlockBetween>
                </BlockHead>

                <ReactDataTable data={stores} columns={dataTableColumns} expandableRows pagination  />
            </Content>
            {/* delete modal */}
            <Modal
                isOpen={modal}
                toggle={() => setModal(false)}
                className="modal-dialog-centered"
            >
                <ModalBody className="pt-3 pb-2">
                    <a
                        href="#cancel"
                        onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                        }}
                        className="close"
                    >
                        <Icon name="cross-sm"></Icon>
                    </a>
                    <div className="p-2">
                        <h5 className="title">
                            Delete Store <Badge color="primary">{deletingStore?.name}</Badge> ?

                        </h5>
                        <div className="mt-2">
                            <span>This store will be deleted. Do you really want to delete this store ?</span>
                        </div>
                        <div className="mt-3">
                            <ul className="align-center flex-wrap flex-sm-nowrap gx-4">
                                <li>
                                    <Button
                                        onClick={(e) => {

                                            onFormSubmit(e);
                                        }}
                                        color="danger"
                                        className="px-4 btn-block"
                                    >

                                        <React.Fragment>Delete</React.Fragment>

                                    </Button>
                                </li>
                                <li>
                                    <a
                                        href="#cancel"
                                        onClick={(ev) => {
                                            ev.preventDefault();
                                            onFormCancel();
                                        }}
                                        className="link link-light"
                                    >
                                        Cancel
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}

export default PendingStores
